<div class="footer-wrapper container">
    <div class="footer">
        <div class="footer__element">
            <span class="element__name">לקוח/ה מאז: </span>
            <span class="element__value">{{ this.custcard_4.registrationDate }}</span>
        </div>
        <div class="footer__element">
            <span class="element__name">ביקור עתידי/אחרון: </span>
            <span class="element__value">{{ this.custcard_4.lastDateVisitStr }}</span>
        </div>
    </div>
</div>
